<template lang="pug">
  .product-invoice
    y-dialog(fill-height fluid v-model="showModal" transition="fade-transition" persistent max-width="400px")
      v-card
        v-card-title(style="height:56px;")
          .h6.basic800--text Upgrade to proceed
        v-divider.basic300
        v-card-text.py-3
          .p2.primary400--text Your current plan does not allow you to do that. Please contact our support to change your subscription plan.
        v-card-actions
          v-spacer
          v-btn.mr-2(color='white', text @click="showModal = !showModal")
            .button-Aa-small.primary400--text Close
</template>

<script>

export default {
  name: 'UpgradePackageDialog',
  props: ['open'],
  components: {  },
  data: () => ({
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<i18n>
{}
</i18n>
